{
"catalog": {
" company has been added": " selskapet har blitt lagt til",
" day. Renew now to continue enjoying uninterrupted access.": " dag. Forny n\u00e5 for \u00e5 fortsette \u00e5 nyte uavbrutt tilgang.",
" days. Renew now to continue enjoying uninterrupted access.": " dager. Forny n\u00e5 for \u00e5 fortsette \u00e5 nyte uavbrutt tilgang.",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0.00",
": The new company has been added": ": Det nye selskapet har blitt lagt til",
"A code of reference ( Who referred a company)": "En referansekode (Hvem henviste et selskap)",
"A link has been sent to your email address to reset password": "En lenke har blitt sendt til e-postadressen din for \u00e5 tilbakestille passordet",
"A link has been sent to your email address to reset password.": "En lenke for \u00e5 tilbakestille passordet er sendt til din e-postadresse.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "En nyere versjon av dette programmet er tilgjengelig. Oppdateringen starter automatisk om 20 sekunder.",
"A suspicious activity was detected. For security reasons, you must log in again": "En mistenkelig aktivitet ble oppdaget. Av sikkerhetsgrunner m\u00e5 du logge inn p\u00e5 nytt",
"API Documentation": "API-dokumentasjon",
"API Key": "API-n\u00f8kkel",
"API key": "API n\u00f8kkel",
"Access from partner website": "Tilgang fra partnerens nettsted",
"Access given": "Tilgang gitt",
"Access is Required!": "Tilgang er p\u00e5krevd!",
"Access period": "Tilgangsperiode",
"Account Setup": "Kontooppsett",
"Account creation code": "Kode for opprettelse av konto",
"Actions": "Handlinger",
"Active": "Aktiv",
"Active Users": "Aktive brukere",
"Active Users List": "Liste over aktive brukere",
"Add": "Legg til",
"Add Contract": "Legg til kontrakt",
"Add Corporate Group": "Legg til konsern",
"Add Customer": "Legg til kunde",
"Add Document": "Legg til dokument",
"Add Historical Data Limit": "Legg til historisk datagrense",
"Add New Corporate Group": "Legg til ny konsern",
"Add New Feature": "Legg til ny egenskap",
"Add New Module": "Legg til ny modul",
"Add New Partner": "Legg til ny partner",
"Add New Subscription": "Legg til Nytt abonnement",
"Add New User": "Opprett ny bruker",
"Add Partner": "Legg til partner",
"Add User": "Legg til bruker",
"Add a new role": "Legg til en ny rolle",
"Add company": "Legg til selskap",
"Add contract": "Legg til kontrakt",
"Add feature": "Legg til funksjon",
"Add permission": "Legg til tillatelse",
"Add role": "Legg til rolle",
"Add subscription plan": "Legg til abonnementsplan",
"Address": "Adresse",
"Aggregated": "Aggregert",
"Aggregation": "Aggregering",
"Alias": "Alias",
"All": "Alle",
"All Documents": "Alle dokumenter",
"All Partners": "Alle Partnere",
"All Users": "Alle brukere",
"All kWh": "Alle kWh",
"All notifications deleted successfully": "Alle varsler er slettet",
"All notifications marked as read": "Alle meldinger merket som lest",
"Alpha numeric and dash only": "Kun alfanumerisk og bindestrek",
"Already have an account?": "Har du allerede en konto?",
"Amount of money for consumption": "Pengebel\u00f8p til forbruk",
"An error occurred while deleting the document": "Det oppstod en feil under sletting av dokumentet",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Det oppsto en feil mens systemet genererte rapporten. Vennligst pr\u00f8v igjen. Du kan kontakte kundest\u00f8tte hvis dette fortsetter.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Det oppstod en uventet feil. Feilen er loggf\u00f8rt, og vi jobber med \u00e5 finne en l\u00f8sning.",
"Annual CO\u2082e (Kg)": "\u00c5rlig CO\u2082e (kg)",
"Annual Statement": "\u00c5rsoppgave",
"Annual energy consumption (kWh)": "\u00c5rlig energiforbruk (kWh)",
"App": "App",
"App URL": "Appens URL",
"Apr": "Apr",
"Apr: Checking": "Apr: Sjekker",
"Apr: Get": "Apr: Get",
"Apr: Update": "Apr: Oppdatering",
"April": "April",
"Are you sure you want to delete this notification ? ": "Er du sikker p\u00e5 at du vil slette denne meldingen? ",
"Are you sure you want to delete?": "Er du sikker p\u00e5 at du vil slette?",
"Attach Company with User": "Legg ved selskap med bruker",
"Aug": "Aug",
"Aug: Checking": "Aug: Sjekker",
"Aug: Get": "Aug: Get",
"Aug: Update": "Aug: Oppdatering",
"August": "August",
"Authority Processing": "Myndighetsbehandling",
"Authorization": "Autorisasjon",
"Availability Payment": "Tilgjengelighet Betaling",
"Availability Rate": "Tilgjengelighet",
"Back": "TIlbake",
"Back to": "Tilbake til",
"Back to Documents": "Tilbake til dokumenter",
"Basic Information": "Stillingsinformasjon",
"Before getting started, could you verify your email address by ": "F\u00f8r du begynner, kan du bekrefte e-postadressen din ved \u00e5 ",
"Blocked": "Blokkert",
"Building": "Hus",
"Building address": "Adresse til bygningen",
"Building is required": "Bygging er n\u00f8dvendig",
"But you still need to know more.": "Men du trenger fortsatt \u00e5 vite mer.",
"CAPTCHA verification failed. Please try again.": "CAPTCHA-verifisering mislyktes. Pr\u00f8v igjen.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "CCPAs personvernrettigheter (ikke selg personopplysningene mine)",
"CO\u2082_per_m2": "CO\u2082_per_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (kg)",
"CVR": "Org nummer",
"Cached": "Cached",
"Cancel": "Avbryt",
"Carbon Emissions (Kg CO\u2082e)": "Karbonutslipp (kg CO\u2082e)",
"Carbon Footprint (g CO\u2082e/kWh)": "Karbonavtrykk (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Forbruk av karbondioksid",
"Cashed Statement - Under Development": "Cashed Statement - under utvikling",
"Central business Register number": "Nummer i det sentrale foretaksregisteret",
"Change Password": "Endre passord",
"Change password": "Endre passord",
"Checking Cache": "Kontrollerer cache",
"Child Company": "Barneselskap",
"Child company and above level access": "Datterselskap og tilgang p\u00e5 h\u00f8yere niv\u00e5",
"City": "Poststed",
"Clear above cache": "T\u00f8m cache",
"Clear all cache": "T\u00f8m all cache",
"Clear browser memory / Page reload": "T\u00f8m nettleserens minne / Last inn siden p\u00e5 nytt",
"Click to copy": "Klikk for \u00e5 kopiere",
"Click to upload or drag and drop": "Klikk for \u00e5 laste opp eller dra og slipp",
"Climate": "Klima",
"Climate report": "Klimarapport",
"Close": "Lukk",
"Co2 Certificates": "CO2-sertifikater",
"Code": "Kode",
"Coming Soon": "Kommer snart",
"Commission Price": "Provisjonspris",
"Commission Share": "Provisjonsandel",
"Companies": "Selskaper",
"Companies for ": "Selskaper for ",
"Companies for the corporate group: ": "Selskaper i konsernet: ",
"Company": "Firma",
"Company Authenticity number": "Selskapets autentisitetsnummer",
"Company Name": "Firmanavn",
"Company No.": "Org. nr.",
"Company Number": "Org nummer",
"Company Roles": "Roller i selskapet",
"Company Users for ": "Bedriftsbrukere for ",
"Company name": "Firmanavn",
"Company website": "Firma webside",
"Compensation": "Kompensasjon",
"Confirm Email Address": "Bekreft epostadresse",
"Confirm Password": "Bekreft passord",
"Confirm Password is required": "Bekreft passord er p\u00e5krevd",
"Confirm password does not match.": "Bekreft passord stemmer ikke overens.",
"Confirmation": "Bekreftelse",
"Congratulations, you\u2019ve chosen the best energy spending platform": "Gratulerer, du har valgt den beste plattformen for energiforbruk",
"Consent": "Samtykke",
"Consumption": "Forbruk",
"Consumption (kWh)": "Forbruk (kWh)",
"Consumption and CO\u2082e": "Forbruk og CO\u2082e",
"Consumption is kWh": "Forbruk er kWh",
"Consumption measured in kWh": "Forbruk m\u00e5lt i kWh",
"Contact Name": "Kontaktperson",
"Contact Phone": "Kontakttelefon",
"Continue": "Fortsett",
"Contract list": "Kontraktsliste",
"Contracts": "Kontrakter",
"Conversion Rate": "Konverteringsrate",
"Conversion Rate for CO\u2082e": "Omregningsfaktor for CO\u2082e",
"Conversion rate in g CO\u2082e/kWh": "Omregningsfaktor i g CO\u2082e/kWh",
"Copied to clipboard": "Kopiert til utklippstavlen",
"Corporate Group": "Konsern",
"Corporate Groups": "Konsern",
"Corporate Groups for the partner ": "Bedriftsgrupper for partneren ",
"Corporate group and above level access": "Konsern og tilgang p\u00e5 h\u00f8yere niv\u00e5",
"Cost": "Kostnad",
"Cost (DKK)": "Kostnad (DKK)",
"Cost in DKK": "Kostnad i DKK",
"Country": "Land",
"Country code": "Landskode",
"Country, Timezone and Corporate Group is Required!": "Land, tidssone og konsern er obligatorisk!",
"Create Historical Data Limit": "Opprett historisk datagrense",
"Create New Contract": "Opprett ny kontrakt",
"Create a new password": "Opprett et nytt passord",
"Create or get an API key to access your data.": "Opprett eller skaff en API-n\u00f8kkel for \u00e5 f\u00e5 tilgang til dataene dine.",
"Created At": "Opprettet den",
"Created By": "Opprettet Av",
"Currency": "Valuta",
"Currency is required": "Valuta er p\u00e5krevd",
"Current Password": "Gjeldende passord",
"Current month only": "Kun innev\u00e6rende m\u00e5ned",
"Current year only": "Kun innev\u00e6rende \u00e5r",
"Customer": "Kunde",
"DKK": "DKK",
"Daily": "Daglig",
"Danish": "Dansk",
"Data Delivered By": "Data levert av",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Datagranularitet. PT1H = hver 1. time, PT15M = hvert 15. minutt",
"Data is currently being loaded. Please hold on a moment.": "Data lastes inn for \u00f8yeblikket. Vennligst vent et \u00f8yeblikk.",
"Data validation - consumption": "Validering av data - forbruk",
"DataHub": "DataHub",
"Date": "Dato",
"Date when the access is given": "Dato for n\u00e5r tilgangen er gitt",
"Day": "Dag",
"Day Report - Under development": "Daglig rapport \u2013 Under utvikling",
"Days": "Dager",
"Dear {{user_full_name}}": "Kj\u00e6re {{user_full_name}}",
"Dec": "Des",
"Dec: Checking": "Desember: Sjekker",
"Dec: Get": "Desember: Get",
"Dec: Update": "Desember: Oppdatering",
"December": "Desember",
"Delete": "Slett",
"Delete API Key": "Slett API-n\u00f8kkel",
"Delete All Notifications": "Slett alle varsler",
"Deleted": "Slettet",
"Description": "Beskrivelse",
"Developer": "Utvikler",
"Did you forget your password? Create a new one by clicking the button below.": "Har du glemt passordet ditt? Opprett et nytt ved \u00e5 klikke p\u00e5 knappen nedenfor.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "Har du f\u00e5tt denne e-posten ved en feiltakelse? I s\u00e5 fall kan du bare ignorere den.",
"Difference": "Forskjell",
"Discount Net Tariff": "Rabatt Netto Tariff",
"Discount Subscription": "Rabattabonnement",
"Distribution": "Distribusjon",
"District Heating": "Fjernvarme",
"Do you know?": "Vet du det?",
"Do you want to delete the document?": "Vil du slette dokumentet?",
"Do you want to delete the historical data limit?": "Vil du slette grensen for historiske data?",
"Do you want to delete the notification?": "\u00d8nsker du \u00e5 slette varselet?",
"Do you want to unlink the company?": "\u00d8nsker du \u00e5 fjerne tilknytningen til selskapet?",
"Do you want to unlink the user?": "\u00d8nsker du \u00e5 fjerne koblingen til brukeren?",
"Document Details": "Dokumentdetaljer",
"Document For": "Dokument for",
"Document Preview": "Dokument-forh\u00e5ndsvisning",
"Document Type": "Dokumenttype",
"Document Uploading Failed": "Dokumentopplasting mislyktes",
"Document deleted successfully": "Dokumentet er slettet",
"Document list": "Dokumentliste",
"Document not found": "Dokumentet ble ikke funnet",
"Document updated successfully": "Dokumentet er oppdatert",
"Document uploaded successfully": "Dokumentet er lastet opp",
"Documents": "Dokumenter",
"Don't Have An Account Yet?": "Har du ikke en konto enn\u00e5?",
"Download": "Last ned",
"Download Climate Report": "Last ned klimarapporten",
"Download Cost Report": "Last ned kostnadsrapport",
"Download Document": "Last ned dokument",
"Download Energy Report": "Last ned energirapport",
"Download For App": "Last ned for app",
"Download For WWW": "Last ned for WWW",
"Download Sport Price Report": "Last ned Sport Price Report",
"Download report": "Last ned rapport",
"Drag and drop files here or click": "Dra og slipp filer her eller klikk",
"Drop the file here or": "Legg inn filen her eller",
"Dutch": "Nederlandsk",
"EPAD": "EPAD",
"EPAD Price": "EPAD-pris",
"EPAD Share": "EPAD-aksjen",
"EPAD Type": "EPAD-type",
"EPAD kWh": "EPAD kWh",
"Edit": "Rediger",
"Edit Contract": "Rediger kontrakt",
"Edit Corporate Group": "Rediger konsern",
"Edit Document Details": "Rediger dokumentdetaljer",
"Edit Feature": "Rediger egenskaper",
"Edit Historical Data Limit": "Rediger historiske datagrenser",
"Edit Module": "Rediger modul",
"Edit Partner": "Rediger partner",
"Edit Role": "Rediger rolle",
"Edit Subscription": "Rediger abonnement",
"Edit User": "Rediger bruker",
"Edit User Company": "Rediger brukerfirma",
"Effect Payment": "Effekt Betaling",
"Effortless energy insights at your fingertips": "Enkel energiinnsikt til fingerspissene",
"Ekskl. moms": "Ekskl. moms",
"Electricity": "Elektrisitet",
"Electricity Charge": "Elektrisitetsavgift",
"Electricity consumption": "Str\u00f8mforbruk",
"Electricity measured in kWh": "Elektrisitet m\u00e5lt i kWh",
"Email": "E-post",
"Email Not Verified": "E-post ikke verifisert",
"Email Sent ": "E-post sendt ",
"Email address": "E-postadresse",
"Email is required.": "E-post m\u00e5 fylles ut.",
"End": "Slutt",
"End Date": "Sluttdato",
"Energy": "Kalorier",
"Energy Consumption (kWh)": "Energiforbruk (kWh)",
"Energy Contract": "Energikontrakt",
"Energy Type": "Energitype",
"Energy report": "Energirepport",
"Energy type is required": "Energitype er p\u00e5krevd",
"English": "Engelsk",
"Enter description": "Skriv inn beskrivelse",
"Enter email": "Skriv inn e-post",
"Enter email address": "Skriv inn e-postadressen",
"Enter email address to continue.": "Skriv inn e-postadresse for \u00e5 fortsette.",
"Enter full name": "Skriv inn fullt navn",
"Enter name": "Skriv inn navn",
"Enter password": "Skriv inn passord",
"Enter password again": "Skriv inn passord igjen",
"Enter your new password to reset": "Skriv inn ditt nye passord for \u00e5 tilbakestille",
"Error loading image:": "Feil ved innlasting av bilde:",
"Error: Something went wrong!": "Feil! Noe gikk galt!",
"Error: Something went wrong! ": "Feil! Noe gikk galt! ",
"Excel Reports": "Excel-rapporter",
"Excel Update": "Excel-oppdatering",
"Expire At": "Utl\u00f8per ved",
"Export": "Eksporter",
"Export to Excel": "Eksporter til Excel",
"Fabeke": "Fabeke",
"Fabeke Data": "Fabeke Data",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke f\u00f8lger en standard prosedyre for bruk av loggfiler. Disse filene logger bes\u00f8kende n\u00e5r de bes\u00f8ker nettsteder. Alle hostingselskaper gj\u00f8r dette, og det er en del av hostingtjenestenes analyseverkt\u00f8y. Informasjonen som samles inn av loggfiler inkluderer IP-adresser (Internet Protocol), nettlesertype, Internett-leverand\u00f8r (ISP), dato- og tidsstempel, henvisnings-/utgangssider og eventuelt antall klikk. Disse er ikke knyttet til informasjon som kan identifisere deg som person. Form\u00e5let med informasjonen er \u00e5 analysere trender, administrere nettstedet, spore brukernes bevegelser p\u00e5 nettstedet og samle inn demografisk informasjon.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "Fabekes personvernerkl\u00e6ring gjelder ikke for andre annons\u00f8rer eller nettsteder. Derfor anbefaler vi deg \u00e5 konsultere de respektive personvernerkl\u00e6ringene til disse tredjeparts annonsetjenerne for mer detaljert informasjon. Det kan inkludere deres praksis og instruksjoner om hvordan du kan velge bort visse alternativer.",
"Failed to delete document": "Kunne ikke slette dokumentet",
"Failed to load document preview. Please try downloading the document.": "Kunne ikke laste inn forh\u00e5ndsvisning av dokumentet. Pr\u00f8v \u00e5 laste ned dokumentet.",
"Failed to unlink. ": "Kunne ikke fjerne koblingen. ",
"Feature": "Egenskap",
"Feature Name": "Navn p\u00e5 funksjon",
"Feature key, Alpha numeric and dash only": "Funksjonstast, kun alfanumerisk og bindestrek",
"Features": "Funksjoner",
"Features for ": "Funksjoner for ",
"Feb": "Feb",
"Feb: Checking": "Feb: Sjekker",
"Feb: Get": "Feb: F\u00e5",
"Feb: Update": "Feb: Oppdatering",
"February": "Februar",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "Ta gjerne kontakt med kundeservice. De er tilgjengelig d\u00f8gnet rundt for \u00e5 hjelpe deg.",
"File Name": "Filnavn",
"File type not supported": "Filtype st\u00f8ttes ikke",
"Fixed": "Fast",
"Fixed Price": "Fastpris",
"Fixed price": "Fastpris",
"Fixed price ex epad": "Fast pris ex epad",
"Fixed price ex epad and profile": "Fast pris ex epad og profil",
"Fixed price ex profile": "Fast pris ab profil",
"Fixed profile ex spot": "Fast profil ex spot",
"For further information, please read CO2 emissions from Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ": "For mer informasjon, vennligst les CO2-utslipp fra Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ",
"Forgot Password": "Glemt passord",
"Forgot Your Password?": "Har du glemt passordet ditt?",
"Forgot your password?": "Glemt passordet?",
"French": "Fransk",
"From": "Fra",
"From date is required": "Fra-dato er p\u00e5krevd",
"Full Name": "Fullt navn",
"Full Year": "Hele \u00e5ret",
"Gain control of your energy spending": "F\u00e5 kontroll over energiforbruket ditt",
"Gas": "Gass",
"Generate API Key": "Generer API-n\u00f8kkel",
"Generate Climate Report": "Generer klimarapport",
"Generate Cost Report": "Generer kostnadsrapport",
"Generate Email": "Generer e-post",
"Generate Energy Report": "Generer energirapport",
"Generate Sport Price Report": "Generer sportsprisrapport",
"Generating Excel file": "Generering av Excel-fil",
"German": "Tysk",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "F\u00e5 full oversikt over energiforbruket ditt med mindre manuelt arbeid",
"Getting Data": "Hente data",
"Go to App": "G\u00e5 til App",
"Green Certificates": "Gr\u00f8nne sertifikater",
"Green Electricity": "Gr\u00f8nn elektrisitet",
"Grid company": "Nettselskapet",
"Heating": "Varme",
"Historical Data": "Historiske data",
"Historical Data Limits": "Historiske datagrenser",
"Hour": "Time",
"Hour Report - Under development": "Timerapport - Under utvikling",
"Hourly": "Hver time",
"Hours": "Timer",
"House No.": "Husnr.",
"How many buildings company have": "Hvor mange bygninger har selskapet",
"How many meters company have": "Hvor mange m\u00e5lere har selskapet",
"I agree with": "Jeg er enig med",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Hvis dataene er tunge, kan det hende at de fortsatt lastes inn.",
"If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.": "Hvis du ikke vil angi noen begrensning, legger du til 999 i tallfeltet. Hvis du ikke vil gi tilgang, kan du h\u00e5ndtere det i abonnementsplanens funksjoner. For \u00e5 implementere denne begrensningen for historiske data m\u00e5 du imidlertid knytte den til abonnementsplanen.",
"InActive": "InAktiv",
"Inkl. Moms": "Inkl. Moms",
"Installation Numbers": "Installasjonsnumre",
"Installation number": "Installasjonsnummer",
"Installation number is required": "Installasjonsnummer er p\u00e5krevd",
"Internet connection restored": "Internettforbindelsen er gjenopprettet",
"Interval": "Intervall",
"Invite User": "Inviter bruker",
"Invoice": "Faktura",
"Invoices": "Fakturaer",
"It appears that no company is associated with your account.": "Det ser ut til at ingen bedrifter er knyttet til kontoen din.",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Den laster ned en zip-fil som inneholder PO- og POT-filene. PO-filen vil inneholde de eksisterende oversettelsene, og POT-filen vil inneholde den nyeste teksten som m\u00e5 oversettes. Vi kan bruke programvaren Poedit til \u00e5 importere POT-teksten til PO-filen og oversette den.",
"Item": "Vare",
"Items": "Elementer",
"Jan": "Jan",
"Jan: Checking": "Jan: Sjekker",
"Jan: Get": "Jan: F\u00e5",
"Jan: Update": "Jan: Oppdatering",
"January": "Januar",
"Japanese": "Japansk",
"Jul": "Jul",
"Jul: Checking": "Jul: Sjekker",
"Jul: Get": "Jul: F\u00e5",
"Jul: Update": "Jul: Oppdatering",
"July": "Juli",
"Jun": "Jun",
"Jun: Checking": "Jun: Sjekker",
"Jun: Get": "Jun: F\u00e5",
"Jun: Update": "Jun: Oppdatering",
"June": "Juni",
"Key": "N\u00f8kkel",
"Key, Alpha numeric and dash only": "N\u00f8kkel, kun alfanumerisk og bindestrek",
"Kg of CO\u2082e": "Kg CO\u2082e",
"Kilogram": "Kilogram",
"LNG": "LNG",
"Language": "Spr\u00e5k",
"Languages": "Spr\u00e5k",
"Last Login": "Siste login",
"Last Run": "Sist kj\u00f8rt",
"Last date": "Siste dato",
"Last seen": "Sist sett",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Som alle andre nettsteder bruker Fabeke informasjonskapsler. Disse informasjonskapslene brukes til \u00e5 lagre informasjon, inkludert de bes\u00f8kendes preferanser og sidene p\u00e5 nettstedet som den bes\u00f8kende har \u00e5pnet eller bes\u00f8kt. Informasjonen brukes til \u00e5 optimalisere brukeropplevelsen ved \u00e5 tilpasse innholdet p\u00e5 nettsidene v\u00e5re basert p\u00e5 den bes\u00f8kendes nettlesertype og/eller annen informasjon.",
"Link": "Link",
"Link User": "Lenke Bruker",
"Link company": "Lenkeselskap",
"Link user": "Lenke bruker",
"List View": "Listevisning",
"List as": "Liste som",
"Loading": "Laster",
"Loading security verification...": "Laster sikkerhetsverifisering...",
"Loading...": "Laster\u2026",
"Location": "Sted",
"Location and above level access": "Beliggenhet og tilgang over niv\u00e5",
"Login": "Logg inn",
"Login as": "Logg inn som",
"Login code": "P\u00e5loggingskode",
"Login failed! Please try again": "Innlogging mislyktes! Vennligst pr\u00f8v igjen",
"Login successful. Redirecting.": "P\u00e5logging vellykket. Omdirigering.",
"Login with your new password right away.": "Logg inn med det nye passordet ditt med en gang.",
"Main Price Type": "Hovedpristype",
"Mandarin": "mandarin",
"Mar": "Mar",
"Mar: Checking": "Mar: Sjekker",
"Mar: Get": "Mar: F\u00e5",
"Mar: Update": "Mar: Oppdatering",
"March": "Mars",
"Mark As Read": "Merk som lest",
"Markup": "Markup",
"Markup Price": "Prisp\u00e5slag",
"Markup Share": "Markup-andel",
"Max size supported 20MB": "Maksimal st\u00f8ttet st\u00f8rrelse 20 MB",
"Maximum 50 symbols": "Maksimalt 50 symboler",
"May": "Mai",
"May: Checking": "Mai: Sjekker",
"May: Get": "Mai: F\u00e5",
"May: Update": "Mai: Oppdatering",
"Message": "Melding",
"Meter": "Meter",
"Meter No": "M\u00e5ler nr",
"Meter and above level access": "M\u00e5ler og tilgang over niv\u00e5",
"Meter number": "M\u00e5lernummer",
"Meter reading end date": "Sluttdato for m\u00e5leravlesning",
"Meter reading start date": "Startdato for m\u00e5leravlesning",
"Minimum 3 symbols": "Minimum 3 symboler",
"Minimum Fee": "Minimumsavgift",
"Modals": "Modalvinduer",
"Module": "Modul",
"Module code, Alpha numeric and dash only": "Modulkode, kun alfanumerisk og bindestrek",
"Module name": "Modulnavn",
"Moms": "M\u00f8dre",
"Month": "M\u00e5ned",
"Month Columns: Downloading": "M\u00e5nedens spalter: Nedlasting",
"Month Columns: Processing": "M\u00e5nedskolonner: Behandling",
"Month Data: Downloading": "M\u00e5nedsdata: Nedlasting",
"Month Data: Processing": "M\u00e5nedsdata: Behandling",
"Month Report - Under development": "M\u00e5nedsrapport - Under utvikling",
"Monthly": "M\u00e5nedlig",
"Monthly Statement": "M\u00e5nedlig oversikt",
"Months": "M\u00e5neder",
"Must be a valid email": "M\u00e5 v\u00e6re en gyldig e-postadresse",
"My Account": "Min konto",
"My Companies": "Mine selskaper",
"My Profile": "Min profil",
"Name": "Navn",
"Name is required.": "Navn er p\u00e5krevd.",
"Natural Gas": "Naturgass",
"Net": "Netto",
"Net Tariff": "Netto Tariff",
"Never Login": "Aldri logg inn",
"New": "Ny",
"New Password": "Nytt passord",
"New Password is required": "Nytt passord er p\u00e5krevd",
"No": "Nei",
"No Company": "Ingen selskap",
"No Documents Found": "Ingen dokumenter funnet",
"No Historical Data Limit": "Ingen begrensning p\u00e5 historiske data",
"No Limit": "Ingen begrensning",
"No Partner": "Ingen partner",
"No Results Found!": "Ingen resultater funnet!",
"No Rows": "Ingen rader",
"No data found": "Ingen data ble funnet",
"No document available for preview": "Ingen dokumenter tilgjengelig for forh\u00e5ndsvisning",
"No internet connection. Please check your network.": "Ingen internettforbindelse. Kontroller nettverket ditt.",
"No option available": "Ingen tilgjengelige alternativer",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "Det er ikke tillatt \u00e5 bruke Fabekes logo eller andre illustrasjoner til lenking uten at det foreligger en varemerkelisensavtale.",
"Norwegian": "Norsk",
"Not Applicable": "Ikke aktuelt",
"Not Cached": "Ikke lagret i hurtigbufferen",
"Not Found": "Ikke funnet",
"Notes": "Merknader",
"Notification has been deleted": "Varsel har blitt slettet",
"Notification marked as read": "Melding merket som lest",
"Notifications": "Varsler",
"Nov": "Nov",
"Nov: Checking": "Nov: Kontroll",
"Nov: Get": "Nov: F\u00e5",
"Nov: Update": "Nov: Oppdatering",
"November": "November",
"Oct": "Okt",
"Oct: Checking": "Okt: Kontroll",
"Oct: Get": "Okt: Get",
"Oct: Update": "Okt: Oppdatering",
"October": "Oktober",
"Official address of meter (not including location information)": "M\u00e5lerens offisielle adresse (ikke inkludert informasjon om plassering)",
"Often the number on company's bill": "Ofte nummeret p\u00e5 selskapets regning",
"Oil": "Olje",
"One Month Energy Consumption (kWh)": "\u00c9n m\u00e5neds energiforbruk (kWh)",
"One Month Tariff (kWh)": "Tariff for \u00e9n m\u00e5ned (kWh)",
"Only PDF files are allowed.": "Kun PDF-filer er tillatt.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Bare PDF-filer er tillatt. La feltet v\u00e6re tomt for \u00e5 beholde den eksisterende filen.",
"Only for system level users": "Kun for brukere p\u00e5 systemniv\u00e5",
"Only lowercase alphanumeric characters and dashes are allowed": "Bare sm\u00e5 alfanumeriske tegn og bindestreker er tillatt",
"Order No": "Ordrenummer",
"Order Numbers": "Bestillingsnummer",
"Others": "\u00d8vrige",
"Overall statement": "Overordnet uttalelse",
"Parameter showing Electricity consumption": "Parameter som viser str\u00f8mforbruk",
"Parent Company": "Morselskap",
"Parent company and above level access": "Morselskap og tilgang p\u00e5 h\u00f8yere niv\u00e5",
"Partner": "Partner",
"Partner Users for ": "Partnerbrukere for ",
"Partner and above level access": "Partner og h\u00f8yere niv\u00e5 tilgang",
"Partners": "Samarbeidspartnere",
"Partnerships Team": "Partnerskapsteamet",
"Password": "Passord",
"Password Changed": "Passordet ble endret",
"Passwords didn't match": "Passordene stemte ikke overens",
"Period/Sum": "Periode/Sum",
"Permissions": "Rettigheter",
"Permissions for ": "Tillatelser for ",
"Personal": "Personlig",
"Personal Information": "Personlig informasjon",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "V\u00e6r ogs\u00e5 oppmerksom p\u00e5 at for \u00e5 beregne utslippsraten fra CO2 brukes 125 %-metoden, noe som betyr at samprodusert varme produseres med en gitt virkningsgrad p\u00e5 125 %.",
"Please authorize us on": "Vennligst autoriser oss p\u00e5",
"Please enter a valid email and password!": "Vennligst oppgi en gyldig e-postadresse og et gyldig passord!",
"Please enter a valid email!": "Vennligst skriv inn en gyldig e-post!",
"Please enter a valid password!": "Vennligst skriv inn et gyldig passord!",
"Please select a file to upload": "Velg en fil du vil laste opp",
"Please wait": "Vennligst vent",
"Please wait while security verification loads...": "Vennligst vent mens sikkerhetsverifiseringen lastes inn...",
"Price": "Pris",
"Price (cent/kWh)": "Pris (cent/kWh)",
"Price (pence/kWh)": "Pris (pence/kWh)",
"Price (\u00d8re/kWh)": "Pris (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Pris (\u00f8re/kWh)",
"Price Price": "Pris Pris",
"Price Share": "Kursandel",
"Price Type": "Pris-type",
"Price elements": "Priselementer",
"Price in (\u00d8re/kWh)": "Pris i (\u00d8re/kWh)",
"Price kWh": "Pris kWh",
"Price type": "Pristype",
"Price type is required": "Pristype er p\u00e5krevd",
"Prices": "Priser",
"Prices, tariffs, taxes and cost": "Priser, tariffer, avgifter og kostnader",
"Privacy Policy": "Personvernerkl\u00e6ring",
"Privacy Policy for Fabeke": "Retningslinjer for personvern for Fabeke",
"Procurement": "Anskaffelser",
"Profile": "Profil",
"Profile Price": "Profilpris",
"Profile Share": "Profilandel",
"Profile Type": "Profiltype",
"Profile kWh": "Profil kWh",
"Q1": "Kvartal 1",
"Q2": "Kvartal 2",
"Q3": "Kvartal 3",
"Q4": "Kvartal 4",
"Quantity (kWh)": "Mengde (kWh)",
"Questions?": "Har du noen sp\u00f8rsm\u00e5l?",
"Rabat Net Tariff": "Rabat Net Tariff",
"Read All Notifications": "Les alle varsler",
"Read Notification": "Les melding",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "Er du klar til \u00e5 forbedre tilbudet ditt? Snakk med noen fra partnerskapsteamet v\u00e5rt i dag og begynn \u00e5 bruke ",
"Real-time, precise, and automated.": "Sanntid, presis og automatisert.",
"Recover Password": "Gjenopprett passord",
"Registered successful. Redirecting.": "Registrert vellykket. Omdirigering.",
"Remove file": "Fjern fil",
"Report": "Rapporter",
"Reports": "Rapporter",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Be om at en virksomhet som samler inn personopplysninger om en forbruker, offentliggj\u00f8r hvilke kategorier og spesifikke personopplysninger virksomheten har samlet inn om forbrukerne.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Be om at en virksomhet som selger forbrukerens personopplysninger, ikke selger forbrukerens personopplysninger.",
"Require all devices to sign in again with the new password.": "Krev at alle enheter logger p\u00e5 igjen med det nye passordet.",
"Reset Completed": "Tilbakestilling fullf\u00f8rt",
"Reset Password": "Tlbakestill passord",
"Reset Your Password": "Tilbakestill passordet ditt",
"Role": "Rolle",
"Role Specific Information": "Rollespesifikk informasjon",
"Role key, Alpha numeric and dash only": "Rolletast, kun alfanumerisk og bindestrek",
"Roles": "Roller",
"Save": "Lagre",
"Save All For": "Lagre alt for",
"Save Changes": "Lagre endringer",
"Save Profile": "Lagre profil",
"Saving. Please wait.": "Lagre. Vennligst vent.",
"Scraper List": "Skrapeliste",
"Scraper Log": "Skrapelogg",
"Scraper Name": "Skraperens navn",
"Search": "S\u00f8k",
"See All Notifications": "Se alle varsler",
"Select": "Velg",
"Select Company": "Velg selskap",
"Select date range": "Velg datointervall",
"Select your locality": "Velg din lokalitet",
"Send Link to Email": "Send lenke til e-post",
"Send the user a notification via email.": "Send brukeren et varsel via e-post.",
"Sep": "Sep",
"Sep: Checking": "Sep: Sjekker",
"Sep: Get": "Sep: F\u00e5",
"Sep: Update": "Sep: Oppdatering",
"September": "September",
"Settings": "Innstillinger",
"Setup a unique password to protect your account.": "Opprett et unikt passord for \u00e5 beskytte kontoen din.",
"Share": "Del",
"Share (%)": "Andel (%)",
"Show up to": "M\u00f8t opp til",
"Sign In": "Logg inn",
"Sign Out": "Logg ut",
"Sign Up": "Registrer deg",
"Sign in": "Logg inn",
"Sign up": "Registrer deg",
"Simple": "Enkel",
"Spanish": "Spansk",
"Spot (60%)": "Spot (60 %)",
"Spot Premium Price": "Spotpremiepris",
"Spot Premium Share": "Spot Premium Andel",
"Spot Price": "Spotpris",
"Spot Prices": "Spotpriser",
"Spot premium": "Spotpremie",
"Spotpris": "Spotpris",
"Start": "Start",
"Start Date": "Startdato",
"Statement": "Utdrag",
"Statement Export": "Uttalelse Eksport",
"Status": "Status",
"Still Loading": "Laster fortsatt",
"Street": "Gateadresse",
"Submit": "Send",
"Subscription": "Abonnement",
"Subscription Expire At": "Abonnementet utl\u00f8per kl.",
"Subscription Expired!": "Abonnementet har utl\u00f8pt!",
"Subscription Expiring Soon!": "Abonnementet utl\u00f8per snart!",
"Subscription Plan": "M\u00e5nedlig betaling",
"Subscription Plan Name": "Navn p\u00e5 abonnementsplan",
"Subscription Plan added Successfully": "Abonnementsplan lagt til vellykket",
"Subscription Plans": "Abonnement planer",
"Subscription key, Alpha numeric and dash only": "Abonnementsn\u00f8kkel, kun alfanumerisk og bindestrek",
"Subscription updated Successfully": "Abonnementet er vellykket oppdatert",
"Sum": "Sum",
"Sum/Average": "Sum/gjennomsnitt",
"Support": "Brukerst\u00f8tte",
"Swedish": "Svensk",
"Switch as": "Bytt som",
"System": "System",
"System Partners": "Systempartnere",
"System Price": "Systempris",
"System Roles": "Systemroller",
"System Share": "Systemandel",
"System Tariff": "Systemtariff",
"System Type": "Systemtype",
"System Users": "Systembrukere",
"System kWh": "System kWh",
"TSO - System Subscription": "TSO - Systemabonnement",
"Take control of your energy expenses with": "Ta kontroll over energiutgiftene dine med",
"Tariff": "Tariff",
"Tax": "Mva",
"Taxes (\u00d8re/kWh)": "Avgifter (\u00d8re/kWh)",
"Taxes in (\u00d8re/kWh)": "Avgifter i (\u00d8re/kWh)",
"Tenants": "Kunder",
"Terms & Conditions": "Vilk\u00e5r og betingelser",
"Test Climate Report": "Rapport om testklima",
"Test Energy Report": "Test energirapport",
"Test Sport Price Report": "Test Sport Prisrapport",
"Test report": "Testrapport",
"Thank you for registering with us. We're excited to have you on board!": "Takk for at du registrerte deg hos oss. Vi gleder oss til \u00e5 ha deg om bord!",
"Thanks for signing up!": "Takk for at du meldte deg p\u00e5!",
"That is great that you know that.": "Det er flott at du vet det.",
"The POC has been updated.": "POC-en har blitt oppdatert.",
"The cache has been cleared": "Cachen har blitt t\u00f8mt",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "Beregningene for CO2-utslippene er basert p\u00e5 utslipp fra hvert kraftverk over 10 MW, og der alle kraftverk under 10 MW regnes som ett kraftverk. Videre er beregningene basert p\u00e5 produksjon per time, forbruk per time og utveksling per time.",
"The company already linked.": "Selskapet er allerede koblet sammen.",
"The company has been linked.": "Selskapet har blitt koblet sammen.",
"The company has been unlinked.": "Selskapet har blitt frakoblet.",
"The data limit has been updated": "Datagrensen har blitt oppdatert",
"The deal has updated": "Avtalen har oppdatert",
"The document has been uploaded.": "Dokumentet er lastet opp.",
"The email has been sent": "E-posten har blitt sendt",
"The file has been exported.": "Filen har blitt eksportert.",
"The historical data limit has been added.": "Den historiske datagrensen er lagt til.",
"The mail already exists in the system!": "Mailen finnes allerede i systemet!",
"The metering point id from datahub": "M\u00e5lepunkt-ID fra datahub",
"The module has been updated": "Modulen har blitt oppdatert",
"The new POC has been added.": "Den nye POC-en er lagt til.",
"The new deal has added": "Den nye avtalen har lagt til",
"The new feature has been added": "Den nye funksjonen har blitt lagt til",
"The new module has been added": "Den nye modulen har blitt lagt til",
"The new partner has been added.": "Den nye partneren er lagt til.",
"The new role has been added.": "Den nye rollen er lagt til.",
"The new user has been added.": "Den nye brukeren er lagt til.",
"The partner has been updated.": "Partneren har blitt oppdatert.",
"The password has been reset.": "Passordet er tilbakestilt.",
"The password has been updated.": "Passordet har blitt oppdatert.",
"The registration is by invitation only.": "Registreringen er kun for inviterte.",
"The role has been updated": "Rollen har blitt oppdatert",
"The session has been expired.": "\u00d8kten er utl\u00f8pt.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "Systemet oppretter n\u00e5 rapporten, og du kan laste den ned ved \u00e5 klikke p\u00e5 Last ned.",
"The user already linked.": "Brukeren er allerede koblet til.",
"The user has been linked.": "Brukeren har blitt koblet til.",
"The user has been unlinked.": "Brukeren har blitt frakoblet.",
"The user has been updated": "Brukeren har blitt oppdatert",
"The year cache has been updated": "\u00c5rsbufferen har blitt oppdatert",
"There are no documents matching your criteria.": "Det finnes ingen dokumenter som samsvarer med dine kriterier.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "Disse vilk\u00e5rene og betingelsene beskriver regler og bestemmelser for bruk av Fabeke's nettsted, som ligger p\u00e5 https://www.fabeke.com",
"Third Party Privacy Policies": "Tredjeparts retningslinjer for personvern",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Tredjeparts annonsetjenere eller annonsenettverk bruker teknologier som informasjonskapsler, JavaScript eller Web Beacons som brukes i deres respektive annonser og lenker som vises p\u00e5 Fabeke, og som sendes direkte til brukernes nettleser. De mottar automatisk IP-adressen din n\u00e5r dette skjer. Disse teknologiene brukes til \u00e5 m\u00e5le effektiviteten av deres reklamekampanjer og/eller til \u00e5 tilpasse reklameinnholdet som du ser p\u00e5 nettsteder du bes\u00f8ker.",
"This area is forbidden. Turn back now!": "Dette omr\u00e5det er forbudt. Snu n\u00e5!",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Dette er en advarsel til alle! Vi har midlertidig stanset nye registreringer. Men ikke v\u00e6r redd, vi \u00e5pner dem igjen om kort tid. Hold dere oppdatert!",
"Thumbnail View": "Miniatyrvisning",
"Time Zone": "Tidssone",
"Timestamp of last encountered when requesting data from datahub": "Tidsstempel for siste gang data ble hentet fra datahub",
"Timezone": "Tidssone",
"To": "Til",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "For \u00e5 fullf\u00f8re registreringen og aktivere kontoen din, vennligst bekreft e-postadressen din ved \u00e5 klikke p\u00e5 knappen nedenfor:",
"To date is required": "Til dags dato er n\u00f8dvendig",
"To ensure the data is tailored to your local time, we require your": "For \u00e5 sikre at dataene er tilpasset din lokale tid, trenger vi din",
"Total Electricity Charge": "Total str\u00f8mavgift",
"Translation": "Oversettelse",
"Transmission Grid Tariff": "Tariff for overf\u00f8ringsnett",
"Type": "Type",
"Type of meter. E17 = consumption, E18 = production": "Type m\u00e5ler. E17 = forbruk, E18 = produksjon",
"URL": "URL",
"Under construction": "Under bygging",
"Unit": "Enhet",
"Unknown Error Occurred !": "Ukjent feil har oppst\u00e5tt!",
"Unknown error1 Occurred !": "Ukjent feil1 oppstod!",
"Unlink": "Koble fra",
"Update": "Oppdater",
"Update Roles": "Oppdater roller",
"Update failed": "Oppdateringen mislyktes",
"Update your Image and other data here.": "Oppdater bildet ditt og andre data her.",
"Updated At": "Oppdatert p\u00e5",
"Updating...": "Oppdaterer...",
"Upload": "Last opp",
"Upload Data": "Last opp data",
"Upload Document Files": "Last opp dokumentfiler",
"Upload New Document": "Last opp nytt dokument",
"Upload New Document File (Optional)": "Last opp ny dokumentfil (valgfritt)",
"Upload PO file": "Last opp PO-fil",
"Upload Po file": "Last opp Po-fil",
"Uploaded": "Lastet opp",
"Uploading": "Laster opp",
"Uploading...": "Laster opp\u2026",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Bruk denne siden til \u00e5 oppdatere applikasjonsversjonen. N\u00e5r du endrer versjonen, vil klientprogrammet automatisk laste ned og kj\u00f8re den nyeste koden fra serveren.",
"Used:": "Brukt:",
"User Data": "Brukerdata",
"User ID is missing": "Bruker-ID mangler",
"Users": "Brukere",
"Users for the business: ": "Brukere for virksomheten: ",
"Users for the corporate group: ": "Brukere for konsernet: ",
"V_per_m2": "V_per_m2",
"Validating period": "Valideringsperiode",
"Validating. Please wait.": "Validerer. Vennligst vent.",
"Validity end date": "Sluttdato for gyldighet",
"Validity start date": "Gyldighetens startdato",
"Variable/Spot/Nordpool price": "Variabel/Spot/Nordpool-pris",
"Verification Successful": "Verifisering vellykket",
"Verify Password": "Verifiser passord",
"Version": "Versjon",
"Version Management": "Versjons administrasjon",
"View": "Vis",
"View Mode": "Vis modus",
"View meter details": "Se detaljer om m\u00e5leren",
"Water": "Sj\u00f8fart",
"We are unable to find your email address": "Vi finner ikke e-postadressen din",
"We couldn't find what you searched for": "Vi fant ikke det du s\u00f8kte etter",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Vi benytter oss av informasjonskapsler. Ved \u00e5 g\u00e5 inn p\u00e5 Fabeke godtar du bruk av informasjonskapsler i samsvar med Fabekes personvernerkl\u00e6ring.",
"We have updated the reports for last month, and you can download the reports by clicking below": "Vi har oppdatert rapportene for forrige m\u00e5ned, og du kan laste ned rapportene ved \u00e5 klikke nedenfor",
"Website": "Nettsted",
"Welcome to": "Velkommen til",
"Welcome to ": "Velkommen til ",
"What do you know?": "Hva vet du om det?",
"Wrong password!": "Feil passord!",
"Year": "\u00c5r",
"Year Data: Downloading": "\u00c5rsdata: Nedlasting",
"Year Data: Processing": "\u00c5rsdata: Behandling",
"Year Report - Under development": "\u00c5rsrapport \u2013 Under utvikling",
"Year: Get": "\u00c5r: Get",
"Year: Update": "\u00c5rstall Oppdatering",
"Yearly": "\u00c5rlig",
"Years": "\u00c5r",
"Yes": "Ja",
"Yes I know that.": "Ja, jeg vet det.",
"You are not authorized to perform this action": "Du er ikke autorisert til \u00e5 utf\u00f8re denne handlingen",
"You can change your password here": "Du kan endre passordet ditt her",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "Du kan velge \u00e5 deaktivere informasjonskapsler via innstillingene i din egen nettleser. Du finner mer detaljert informasjon om h\u00e5ndtering av informasjonskapsler med spesifikke nettlesere p\u00e5 de respektive nettlesernes nettsider.",
"You can continue to use our services now. ": "Du kan fortsette \u00e5 bruke tjenestene v\u00e5re n\u00e5. ",
"You can now use your new password to sign in to your account.": "Du kan n\u00e5 bruke det nye passordet til \u00e5 logge p\u00e5 kontoen din.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "Du kan bare laste opp PO-filen. Etter at du har lastet opp filen, tar det nesten 10 minutter f\u00f8r endringene gjenspeiles p\u00e5 nettstedet.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Du har blitt invitert av {{partner_name}} til \u00e5 bli med som {{role_name}}. For \u00e5 fortsette, klikker du p\u00e5 Logg inn for \u00e5 f\u00e5 tilgang til systemet.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Du er invitert av {{partner_name}} til \u00e5 bli med som {{role_name}}. For \u00e5 fortsette m\u00e5 du opprette et passord for \u00e5 f\u00e5 tilgang til systemet.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Du har blitt invitert av {{tenant_name}} til \u00e5 bli med som {{role_name}}. For \u00e5 fortsette, klikker du p\u00e5 Logg inn for \u00e5 f\u00e5 tilgang til systemet.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Du er invitert av {{tenant_name}} til \u00e5 bli med som {{role_name}}. For \u00e5 fortsette m\u00e5 du opprette et passord for \u00e5 f\u00e5 tilgang til systemet.",
"Your Picture": "Ditt bilde",
"Your account doesn\u2019t exist, please Sign Up": "Kontoen din finnes ikke, vennligst registrer deg",
"Your login session has been expired. Please log in again": "Innloggings\u00f8kten din er utl\u00f8pt. Vennligst logg inn p\u00e5 nytt",
"Your password has been changed": "Passordet ditt har blitt endret",
"Your password has been successfully reset.": "Passordet ditt er tilbakestilt.",
"Your private file": "Din private fil",
"Your profile has been updated": "Profilen din har blitt oppdatert",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Abonnementet ditt har utl\u00f8pt. Forny n\u00e5 for \u00e5 f\u00e5 tilgang til kontoen din og alle premiumfunksjonene igjen.",
"Your subscription will expire in": "Abonnementet ditt utl\u00f8per om",
"Zip Code": "Postnummer",
"aggregated": "samlet",
"all": "alle",
"and": "og",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "og Fabeke Tech tar ikke ansvar for eventuelle feil i innsendte data og lister",
"browse": "bla gjennom",
"cache has been updated": "hurtigbufferen har blitt oppdatert",
"clicking the link we just emailed you at ": "ved \u00e5 klikke p\u00e5 lenken vi nettopp sendte deg p\u00e5 ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "samler inn energidata, priser og karbonutslipp fra alle relevante datakilder og presenterer energiforbruk, priser, avgifter, kostnader og karbonutslipp i v\u00e5r plattform for energiutgifter.",
"comprehensive data and insights": "omfattende data og innsikt",
"contact us": "kontakt oss",
"converts data into your language and local time zone": "konverterer data til ditt spr\u00e5k og din lokale tidssone",
"country, timezone and corporate group": "land, tidssone og konsern",
"does not take responsibility for any errors in submitted data and lists": "tar ikke ansvar for feil i innsendte data og lister",
"export": "eksporter",
"export to CSV": "eksport til CSV",
"export to Excel": "eksport til Excel",
"export to PDF": "eksport til PDF",
"files": "filer",
"for any queries.": "for eventuelle sp\u00f8rsm\u00e5l.",
"g CO\u2082/kW": "g CO\u2082/kW",
"g CO\u2082e/kW": "g CO\u2082e/kW",
"gives you": "gir deg",
"https://www.example.com": "https://www.example.com",
"into your energy usage, costs, and carbon footprint.": "i energibruk, kostnader og karbonavtrykk.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "for \u00e5 m\u00e5le karbondioksidforbruket. potensialforskjellen over et overflateareal, bruker vi enheten karbondioksid per kvadratmeter (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "n\u00e5r vi m\u00e5ler den elektriske potensialforskjellen over en overflate, bruker vi enheten volt per kvadratmeter (V/m2)",
"or": "eller",
"page": "side",
"q": "q",
"real-time, accurate insights": "n\u00f8yaktig innsikt i sanntid",
"ubscription Expire A": "Abonnement utl\u00f8per A",
"v": "v"
},
"plural": "(n != 1)"
}